import React from 'react';
import HowItWorks from './HowItWorks';
import DeepDive from './DeepDive';

const InfoSection: React.FC = () => {
  return (
    <div className="w-full mt-12 mb-8 border-t border-terminal-green/30 pt-8">
      <h2 className="text-2xl font-vt323 mb-6 text-terminal-green text-center">ABOUT SCACCHI.AI</h2>
      
      <div className="grid grid-cols-1 gap-8">        
        {/* Import the DeepDive component */}
        <DeepDive />
      </div>
      
      <div className="text-center mt-8">
        <p className="text-terminal-green/70 italic">
        Can a language model beat you at chess… or is it just parroting what it read?
        </p>
      </div>
    </div>
  );
};

export default InfoSection;